import {useSelector} from 'react-redux';

export default function useParamSelector<T = unknown>(
  // A selector of any state shape and any parameter list. `unknown[]` compiles
  // here only because the package is `strict: false`; under strictFunctionTypes
  // parameter contravariance rejects every real selector, so `any` is the
  // honest type.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selector: (...args: any[]) => T,
  ...params: unknown[]
): T {
  return useSelector((state) => selector(state, ...params));
}
